import useDismissUndoablesOnNavigation from '../hooks/useDismissUndoablesOnNavigation'
import useUndoDeleteShortcut from '../hooks/useUndoDeleteShortcut'

const GlobalUndoDeleteListener = () => {
	useUndoDeleteShortcut()
	useDismissUndoablesOnNavigation()
	return null
}

export default GlobalUndoDeleteListener
